import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-warning.tsx
/**
* icon.24.warning
*
* Attention, warning, exclamation mark
*
* Keywords: alert, triangle, exclamation, caution, error, notification, danger, attention
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjU3IDYuMDZjLjc2NC0xLjM2IDIuNzIyLTEuMzYgMy40ODYgMGw1LjA0IDguOTZjLjc1IDEuMzMzLS4yMTMgMi45OC0xLjc0MyAyLjk4SDYuOTZjLTEuNTMgMC0yLjQ5My0xLjY0Ny0xLjc0My0yLjk4bC44Ny40OWExIDEgMCAwIDAgLjczMyAxLjQ4bC4xNC4wMWgxMC4wOGExIDEgMCAwIDAgLjg3Mi0xLjQ5bC0uMDAxLS4wMDEtNS4wNC04Ljk2YTEgMSAwIDAgMC0xLjc0MiAwbC01LjA0MSA4Ljk2LS44NzEtLjQ5ek0xMiAxNC4wMDNhLjc1Ljc1IDAgMSAxIDAgMS41Ljc1Ljc1IDAgMCAxIDAtMS41TTEyIDguNWMuNDI1IDAgLjc2LjM2LjczLjc4NWwtLjIzMSAzLjI1YS41LjUgMCAwIDEtLjk5OCAwbC0uMjMyLTMuMjVBLjczMy43MzMgMCAwIDEgMTIgOC41IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1942
*/
const Icon24Warning = memo(function Icon24Warning(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10.257 6.06c.764-1.36 2.722-1.36 3.486 0l5.04 8.96c.75 1.333-.213 2.98-1.743 2.98H6.96c-1.53 0-2.493-1.647-1.743-2.98l.87.49a1 1 0 0 0 .733 1.48l.14.01h10.08a1 1 0 0 0 .872-1.49l-.001-.001-5.04-8.96a1 1 0 0 0-1.742 0l-5.041 8.96-.871-.49zM12 14.003a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M12 8.5c.425 0 .76.36.73.785l-.231 3.25a.5.5 0 0 1-.998 0l-.232-3.25A.733.733 0 0 1 12 8.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Warning };

//# sourceMappingURL=icon-24-warning.js.map